import React, { Component } from 'react'
import Search from './Search'
import './App.css'

export class App extends Component {
    render() {

        return (
            <div>
                <Search/>
            </div>
        )
    }
}

export default App
